import { render } from "./EditSupplierComponent.vue?vue&type=template&id=7e84b526&scoped=true"
import script from "./EditSupplierComponent.vue?vue&type=script&lang=js"
export * from "./EditSupplierComponent.vue?vue&type=script&lang=js"

import "./EditSupplierComponent.vue?vue&type=style&index=0&id=7e84b526&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e84b526"]])

export default __exports__